var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCustomerWishlist } from '../services';
import { checkFallbackFn } from '../utils';
export var useWishlistCache = function (config, logger) { return function () {
    var getData = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, fallback, id, action, ignoreId, price, title, shouldCallService, _b, items, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = params || {}, fallback = _a.fallback, id = _a.id, action = _a.action, ignoreId = _a.ignoreId, price = _a.price, title = _a.title;
                    shouldCallService = (id && action) || (ignoreId && action);
                    if (!(config.isMiniApp && shouldCallService)) return [3 /*break*/, 2];
                    return [4 /*yield*/, useCustomerWishlist({ action: action, id: id, price: price, title: title }, logger)];
                case 1:
                    _b = _c.sent(), items = _b.items, error = _b.error;
                    return [2 /*return*/, {
                            data: { items: items === null || items === void 0 ? void 0 : items.map(function (_a) {
                                    var sku = _a.sku;
                                    return ({ id: sku });
                                }), expireIn: 0 },
                            error: {
                                message: error === null || error === void 0 ? void 0 : error.message,
                            },
                        }];
                case 2:
                    if (checkFallbackFn(fallback)) {
                        logger.debug("[useWishlist] - Using fallback function - action ".concat(action));
                        return [2 /*return*/, fallback()];
                    }
                    _c.label = 3;
                case 3: return [2 /*return*/, {
                        data: {
                            items: [],
                            expireIn: 0,
                        },
                        error: {
                            message: '[useWishlist] - Please provide a id or use a fallback method',
                        },
                    }];
            }
        });
    }); };
    var append = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var fallback = _b.fallback, id = _b.id, price = _b.price, title = _b.title;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getData({ action: 'add', fallback: fallback, id: id, price: price, title: title })];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var remove = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var fallback = _b.fallback, id = _b.id;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getData({ action: 'remove', fallback: fallback, id: id })];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var get = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var fallback = _b.fallback, id = _b.id, _c = _b.ignoreId, ignoreId = _c === void 0 ? true : _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, getData({ action: 'search', fallback: fallback, id: id, ignoreId: ignoreId })];
                case 1: return [2 /*return*/, _d.sent()];
            }
        });
    }); };
    var isFeatureEnable = function (_a) {
        var fallback = _a.fallback, defaultValue = _a.defaultValue;
        if (config.isMiniApp) {
            return defaultValue;
        }
        else if (checkFallbackFn(fallback)) {
            logger.debug("[useWishlist] - Using fallback function");
            return fallback();
        }
    };
    var exists = function (_a) {
        var fallback = _a.fallback;
        return isFeatureEnable({ fallback: fallback, defaultValue: true });
    };
    var autoSync = function (_a) {
        var fallback = _a.fallback;
        return isFeatureEnable({ fallback: fallback, defaultValue: false });
    };
    return { append: append, remove: remove, get: get, exists: exists, autoSync: autoSync };
}; };
